export default "__VITE_ASSET__ce46b9d3__"